module.exports = __webpack_public_path__ + "media/images/fm_7-99efdff3d584f6667c253b7015eddc16.png";